import { render, staticRenderFns } from "./headerWtxh.vue?vue&type=template&id=ad326ff4&scoped=true"
import script from "./headerWtxh.vue?vue&type=script&lang=js"
export * from "./headerWtxh.vue?vue&type=script&lang=js"
import style0 from "./headerWtxh.vue?vue&type=style&index=0&id=ad326ff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad326ff4",
  null
  
)

export default component.exports